import React from 'react';
import CommonModal from './common/Modal';

const ExternalServiceCooperationTermsOfServiceDialog = props => {
  const { visible = false, onClose, onSubmit } = props || {};

  return (
    <CommonModal visible={visible}>
      <div className='dialog dialog--full dialog--modal ExternalServiceCooperationTermsOfServiceDialog'>
        <div className='dialog__header'>
          <span className='dialog__title'>外部サービス連携利用規約</span>
        </div>

        <div className='dialog__body'>
          <div className='ExternalServiceCooperationTermsOfServiceDialog__note'>
            Buildee利用規約およびプライバシーポリシーの他、下記項目に同意の上、ご登録ください。
          </div>
          <div className='ExternalServiceCooperationTermsOfServiceDialog__body'>
            <div className='ExternalServiceCooperationTermsOfServiceDialog__contents'>
              <p className='block'>第1条（総則）</p>
              <p className='block'>
                1
                「外部サービス連携」とは、株式会社リバスタ（以下「当社」といいます。）が提供する各クラウドサービス（以下「当社サービス」といいます。）において、他社が運営するサービス（以下「外部サービス」といいます。）を利用するために、当社サービスの会員であるお客様（以下「利用者」といいます。）の希望に基づき、当社サービスと外部サービスを連携させるサービス（以下「本サービス」といいます。）をいいます。
              </p>
              <p className='block'>
                2
                外部サービス連携利用規約（以下「本規約」といいます。）は、本サービスを利用するすべて利用者が遵守すべき事項を定めたものです。利用者は、本規約の他、当社サービスに係る利用規約及びこれに付随する各規約（以下総称して「サービス規約等」といいます。）の定めに従うものとします。
              </p>
              <br />
              <p className='block'>
                第2条（本サービスの利用契約）
                <br />
                利用者は、本サービスの利用を希望する場合、当社所定の方法により本サービスの利用を申し込むものとし、当社がこれに承諾をした場合に、当社及び利用者間において、本規約に基づく本サービスの利用契約が成立します。
              </p>
              <br />
              <p className='block'>
                第3条（外部サービスの利用契約）
                <br />
                利用者は、外部サービスの利用にあたり、その運営事業者（以下「外部サービス事業者」といいます。）との契約が必要となる場合、自らの責任において外部サービス事業者又はその代理店との間で、外部サービスの利用契約を締結するものとします。
              </p>
              <br />
              <p className='block'>第4条（情報の取り扱い）</p>
              <p className='block'>
                1
                利用者は、本サービスの利用にあたり、外部サービスに登録された情報（以下「外部サービス情報」といいます。）を当社が取得し、当社サービスに登録された情報（以下「当社サービス情報」といいます。）を外部サービスに連携して表示する場合があることを承諾するものとします。
              </p>
              <p className='block'>
                2
                利用者は、本サービスの利用にあたり、外部サービスにおいて、当社サービス情報を取り扱う場合、当該取り扱いに係る一切の責任を負うものとし、これにより利用者又は第三者に損害が生じたとしても、当社は一切責任を負いません。また、かかる事由により、当社が損害を負った場合には、利用者は、当社が被った一切の損害及び損失を賠償ないし補償するものとします。
              </p>
              <p className='block'>
                3
                利用者は、本サービスの利用にあたり、当社サービスにおいて、外部サービス情報を取り扱う場合、当該取り扱いに係る一切の責任を負うものとし、これにより利用者又は第三者に損害が生じたとしても、当社は一切責任を負いません。また、かかる事由により、当社が損害を負った場合には、利用者は、当社が被った一切の損害及び損失を賠償ないし補償するものとします。但し、当社の故意または重過失に起因する場合はこの限りではありません。
              </p>
              <p className='block'>
                4
                当社は、本サービスにより取得した外部サービス情報のうち、個人情報については、当社のプライバシーポリシーに従って取り扱うものとします。
              </p>
              <br />
              <p className='block'>第5条（外部サービスの利用） </p>
              <p className='block'>
                1
                利用者は、外部サービスにおけるアカウント及びパスワードの登録・管理・利用に際して、外部サービス事業者が定める各規約に従い、自己の責任において行うものとします。利用者の外部サービスアカウント及びパスワードの管理不十分、使用上の過誤、第三者の使用などにより、利用者又は第三者に損害が生じた場合、当該責任は利用者が負うものとし、当社は一切責任を負いません。また、かかる事由により、当社が損害を負った場合には、利用者はその一切の責任を負い、当社が被った一切の損害及び損失を賠償ないし補償するものとします。
              </p>
              <p className='block'>
                2
                外部サービスに不具合等に起因して、本サービスが利用できない場合、当社はその責を負いません。
              </p>
              <br />
              <p className='block'>第6条（費用）</p>
              <p className='block'>
                1
                本サービスの利用料は、当社ホームページに記載の料金表等に定めるものとします。なお、外部サービスの利用料金は、外部サービス事業者が定める各規約等に従うものとします。
              </p>
              <p className='block'>
                2
                利用者は、本サービスの提供を受けるために必要な機器及び通信手段等を自己の費用と責任で備えます。また、本サービスの利用にあたり必要となる通信費用は、全て利用者の負担とします。
              </p>
              <br />
              <p className='block'>第7条（非保証・免責） </p>
              <p className='block'>
                1
                当社は、利用者に対して、以下の各号の事項について、一切の保証をしません。
                <br />
                （1）本サービスの完全性、正確性、有効性及び特定目的への適合性
                <br />
                （2）本サービスの変更、中断、終了及び障害が生じないこと
              </p>
              <br />
              <p className='block'>
                2
                当社は、以下の各号の損害について、一切の責任を負いません。
                <br />
                （1）利用者が本サービスの利用にあたり必要となる情報の登録又は変更を行わなかったことにより利用者に生じた損害
                <br />
                （2）予期しない不正アクセス等の行為により利用者に生じた損害
                <br />
                （3）本サービスの利用に関連して利用者が日本又は外国の法令に触れたことにより利用者に生じた損害
                <br />
                （4）天災、地変、火災、ストライキ、通商停止、戦争、内乱、疫病・感染症の流行その他の不可抗力により本サービスの全部又は一部に不履行が発生した場合、利用者に生じた損害
                <br />
                （5）本サービスの利用に関し、利用者が第三者との間でトラブル（本サービス内外を問いません。）になった場合、利用者に生じた損害
              </p>
              <br />
              <p className='block'>
                第8条（本サービスの変更、中断、終了）
              </p>
              <p className='block'>
                1
                当社は、本サービスについて、その変更、中断及び終了を、自己の裁量で自由に決定できるものとします。
              </p>
              <p className='block'>
                2
                当社は、前項において、必要と判断した場合には、サービス規約等に定める方法にて利用者に通知します。
              </p>
              <br />
              <p className='block'>
                第9条（規約の変更など）
                <br />
                当社は利用者に対しサービス規約等に定めるいずれかの連絡方法を用いてあらかじめ利用者に通知することにより、本規約の変更、修正をすることがあります。変更後の本規約は、当社が別途定める場合を除き、本サイト上に表示した時点より効力を生じるものとします。利用者が、本規約変更の効力が生じた後に本サービスをご利用になる場合には、変更後の本規約に記載されているすべての事項に同意したものとみなされます。
              </p>
              <br />
              <p>付&emsp;則（本規約の発効）</p>
              本規約は下記のとおり、発効し、改定されました。
              <br />
              <p className='footer'>
                ●発&emsp;効：2021年8月29日
                <br />
                ●第1回改定：2022年4月1日
                <br />
                ●第2回改定：2024年5月26日
              </p>
              <br />
            </div>
          </div>
        </div>

        <div className='dialog__footer dialog__footer--horizontal'>
          <button
            className='btn-fixedsize--sub'
            onClick={onClose ? onClose : undefined}
          >
            同意しない
          </button>
          <span> </span>
          <button
            className='btn-fixedsize--effective'
            onClick={onSubmit ? onSubmit : undefined}
          >
            同意
          </button>
        </div>
      </div>
    </CommonModal>
  );
};

export { ExternalServiceCooperationTermsOfServiceDialog };



// WEBPACK FOOTER //
// ./src/components/modals/ExternalServiceCooperationTermsOfServiceDialog.jsx